// extracted by mini-css-extract-plugin
export var errorIcon = "_k2-1";
export var nameLogo = "_k2-0";